import { Component } from '@angular/core';
import { AppService } from '@services/app.service';

@Component({
  selector: 'app-eng-home',
  standalone: true,
  imports: [],
  templateUrl: './eng-home.component.html',
  styleUrl: './eng-home.component.scss'
})
export class EngHomeComponent {
  constructor(
    private appService: AppService
  ){}

  logout(){
    this.appService.logout();
  }
}
